export default "<ng-container>{{ _data }}</ng-container>\n"